module.exports = __webpack_public_path__ + "static/img/ZW.4bc48612.png";